import { DesignInputSpeakAs } from '../../types';

export const speakAsOptions = [
  {
    value: DesignInputSpeakAs.addressCity,
    name: 'Address City',
    defaultValue: 'Franklin'
  },
  {
    value: DesignInputSpeakAs.addressStreet,
    name: 'Address Street',
    defaultValue: 'Hayward St'
  },
  {
    value: DesignInputSpeakAs.asIs,
    name: 'As Is',
    defaultValue: 'as is'
  },
  {
    value: DesignInputSpeakAs.character,
    name: 'Character',
    defaultValue: 'I'
  },
  {
    value: DesignInputSpeakAs.company,
    name: 'Company',
    defaultValue: 'Interactions'
  },
  {
    value: DesignInputSpeakAs.currency,
    name: 'Currency',
    defaultValue: '$1.00'
  },
  {
    value: DesignInputSpeakAs.date,
    name: 'Date',
    defaultValue: 'January 1, 2020'
  },
  {
    value: DesignInputSpeakAs.digit,
    name: 'Digit',
    defaultValue: '1'
  },
  {
    value: DesignInputSpeakAs.internet,
    name: 'Internet',
    defaultValue: '@interactions.com'
  },
  {
    value: DesignInputSpeakAs.name,
    name: 'Name',
    defaultValue: 'Jane Doe'
  },
  {
    value: DesignInputSpeakAs.number,
    name: 'Number',
    defaultValue: '12345'
  },
  {
    value: DesignInputSpeakAs.phoneNumber,
    name: 'Phone Number',
    defaultValue: '123-456-7890'
  },
  {
    value: DesignInputSpeakAs.phoneticSpelling,
    name: 'Phonetic Spelling',
    defaultValue: 'I as in Interactions'
  },
  {
    value: DesignInputSpeakAs.phoneticWord,
    name: 'Phonetic Word',
    defaultValue: 'dog'
  },
  {
    value: DesignInputSpeakAs.phrase,
    name: 'Phrase',
    defaultValue: 'This is a phrase'
  },
  {
    value: DesignInputSpeakAs.spelling,
    name: 'Spelling',
    defaultValue: 'I n t e r a c t i o n s'
  },
  {
    value: DesignInputSpeakAs.time,
    name: 'Time',
    defaultValue: '5pm'
  },
  {
    value: DesignInputSpeakAs.translationCode,
    name: 'Translation Code',
    defaultValue: '12345'
  },
  {
    value: DesignInputSpeakAs.word,
    name: 'Word',
    defaultValue: 'dog'
  }
];
